import { AlertTriangle } from 'lucide-react'

export interface RejectionInfoProps {
  reason: string
  rejectedBy?: string
  rejectedAt?: string
}

export function RejectionInfo({ reason, rejectedAt }: RejectionInfoProps): React.ReactElement {
  return (
    <div className="flex items-start gap-3 rounded-lg border border-amber-200 bg-amber-50 p-4 dark:border-amber-900/50 dark:bg-amber-900/20">
      <AlertTriangle className="mt-0.5 h-5 w-5 shrink-0 text-amber-600 dark:text-amber-400" />
      <div className="min-w-0 text-sm">
        <p className="font-medium text-amber-800 dark:text-amber-200">Rejected</p>
        <p className="mt-1 text-amber-700 dark:text-amber-300">{reason}</p>
        {rejectedAt && (
          <p className="mt-1 text-xs text-amber-600 dark:text-amber-400">
            {new Date(rejectedAt).toLocaleString()}
          </p>
        )}
      </div>
    </div>
  )
}

RejectionInfo.displayName = 'RejectionInfo'
